module.exports = __webpack_public_path__ + "img/methoden_3000.76d5dacd.webp";